import { Store, createStore, applyMiddleware } from 'redux'
import reducer from './reducer'
import reduxThunk from 'redux-thunk'
import apiConfig from './config/api.json'
import apiMiddleware from './modules/api'

const store: Store = createStore(reducer, applyMiddleware(
  reduxThunk,
  apiMiddleware(apiConfig)
))

export default store
